import Highcharts from 'highcharts';
import Exporting from 'highcharts/modules/exporting';
import setHighchartsOptions from 'highcharts_init';

Exporting(Highcharts);

(function () {
  if (typeof AnnualReportingJson !== 'undefined') {
    function zeroCleaned (series) {
      series[0].data.forEach(function (datum, i) {
        if (datum.y <= 0) {
          series[0].data.splice(i, 1);
        }
      });

      return series;
    }

    setHighchartsOptions();
    function chartObj (chartSeries, chartTitle) {
      return {
        chart: {
          backgroundColor: '#eee',
          type: 'pie',
        },
        colors: [
          '#4572A7',
          '#AA4643',
          '#89A54E',
          '#80699B',
          '#3D96AE',
          '#DB843D',
          '#92A8CD'
        ],
        title: {
          text: chartTitle
        },
        tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
        },
        legend: {
          itemWidth: 200,
          itemMarginBottom: 3,
          itemStyle: {
            fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true,
            size: 200
          }
        },
        series: zeroCleaned(chartSeries),
        credits: {
          enabled: false
        },
        lang: {
          download_key: 'Download'
        },
        exporting: {
          buttons: {
            contextButton: {
              _titleKey: "download_key",
              enabled: true,
              menuItems: [
                {
                  text: "Download PNG",
                  onclick: function() {
                    this.exportChart();
                  }
                },
                {
                  text: "Download JPEG",
                  onclick: function() {
                    this.exportChart({
                      type: 'image/jpeg',
                    });
                  }
                },
                {
                  text: "Download PDF",
                  onclick: function() {
                    this.exportChart({
                      type: 'application/pdf',
                    });
                  }
                }
              ]
            },
          }
        }
      }
    }

    function addDelimiter(nStr){
      nStr += '';
      var x = nStr.split('.');
      var x1 = x[0];
      var x2 = x.length > 1 ? '.' + x[1] : '';
      var rgx = /(\d+)(\d{3})/;
      while (rgx.test(x1)) {
        x1 = x1.replace(rgx, '$1' + ',' + '$2');
      }
      return x1 + x2;
    }

    var petSav = [{
      name: 'Savings',
      data: [{
        name: "Alternative Fuel Vehicles",
        y: AnnualReportingJson.association_totals.afvs_fuel_blends.gge_reduced_doe
      }, {
        name: "Fuel Economy Improvements",
        y: AnnualReportingJson.association_totals.fuel_economy_improvements.gge_reduced_doe
      }, {
        name: "Idle Reductions",
        y: AnnualReportingJson.association_totals.idle_reductions.gge_reduced_doe
      }, {
        name: "Off Road Vehicles",
        y: AnnualReportingJson.association_totals.off_road_vehicles.gge_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.association_totals.electrics_evs_phevs.gge_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.association_totals.electrics_hevs.gge_reduced_doe
      }, {
        name: "Vehicle Miles Traveled Reductions",
        y: AnnualReportingJson.association_totals.vmt_reductions.gge_reduced_doe
      }]
    }];

    Highcharts.chart('pet-sav', chartObj(petSav, 'Annual Petroleum Savings'));

    var petSavTotal = AnnualReportingJson.association_totals.gge_reduced_doe_total;

    $('#pet-sav-total').text(addDelimiter(Math.round(petSavTotal)) + ' gasoline gallon equivalents');

    var petSavByProj = [{
      name: 'Savings',
      data: [{
        name: "Biodiesel",
        y: AnnualReportingJson.afv_fuel_totals.biodiesel.gge_reduced_doe
      }, {
        name: "Natural Gas (CNG)",
        y: AnnualReportingJson.afv_fuel_totals.CNG.gge_reduced_doe
      }, {
        name: "Ethanol (E85)",
        y: AnnualReportingJson.afv_fuel_totals.E85.gge_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.electricity.gge_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.HEV.gge_reduced_doe
      }, {
        name: "Hydrogen",
        y: AnnualReportingJson.afv_fuel_totals.H2.gge_reduced_doe
      }, {
        name: "Liquefied Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.LNG.gge_reduced_doe
      }, {
        name: "Propane (LPG)",
        y: AnnualReportingJson.afv_fuel_totals.LPG.gge_reduced_doe
      }, {
        name: "Plug-in Hybrid",
        y: AnnualReportingJson.afv_fuel_totals.PHEV.gge_reduced_doe
      }]
    }];

    Highcharts.chart('pet-sav-by-proj', chartObj(petSavByProj, 'Annual Petroleum Savings by Alternative Fuel Vehicle Project Type'));

    var petSavByProjTotal = AnnualReportingJson.afv_fuel_totals.totals.gge_reduced_doe;

    $('#pet-sav-by-proj-total').html(addDelimiter(Math.round(petSavByProjTotal)) + ' gasoline gallon equivalents');

    var greenGasAvoided = [{
      name: 'Avoided',
      data: [{
        name: "Alternative Fuel Vehicles",
        y: AnnualReportingJson.association_totals.afvs_fuel_blends.ghg_reduced_doe
      }, {
        name: "Fuel Economy Improvements",
        y: AnnualReportingJson.association_totals.fuel_economy_improvements.ghg_reduced_doe
      }, {
        name: "Idle Reductions",
        y: AnnualReportingJson.association_totals.idle_reductions.ghg_reduced_doe
      }, {
        name: "Off Road Vehicles",
        y: AnnualReportingJson.association_totals.off_road_vehicles.ghg_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.association_totals.electrics_evs_phevs.ghg_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.association_totals.electrics_hevs.ghg_reduced_doe
      }, {
        name: "Vehicle Miles Traveled Reductions",
        y: AnnualReportingJson.association_totals.vmt_reductions.ghg_reduced_doe
      }]
    }];

    Highcharts.chart('green-gas-avoided', chartObj(greenGasAvoided, 'Annual Greenhouse Gas Emission Avoided'));

    var greenGasAvoidedTotal = AnnualReportingJson.association_totals.ghg_reduced_doe_total;

    $('#green-gas-avoided-total').html(addDelimiter(Math.round(greenGasAvoidedTotal)) + ' tons of carbon dioxide-equivalent (CO2e)');

    var greenGasByProj = [{
      name: 'Avoided',
      data: [{
        name: "Biodiesel",
        y: AnnualReportingJson.afv_fuel_totals.biodiesel.ghg_reduced_doe
      }, {
        name: "Natural Gas (CNG)",
        y: AnnualReportingJson.afv_fuel_totals.CNG.ghg_reduced_doe
      }, {
        name: "Ethanol (E85)",
        y: AnnualReportingJson.afv_fuel_totals.E85.ghg_reduced_doe
      }, {
        name: "Electric & Plug-In Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.electricity.ghg_reduced_doe
      }, {
        name: "Hybrid Vehicles",
        y: AnnualReportingJson.afv_fuel_totals.HEV.ghg_reduced_doe
      }, {
        name: "Hydrogen",
        y: AnnualReportingJson.afv_fuel_totals.H2.ghg_reduced_doe
      }, {
        name: "Liquefied Natural Gas",
        y: AnnualReportingJson.afv_fuel_totals.LNG.ghg_reduced_doe
      }, {
        name: "Propane (LPG)",
        y: AnnualReportingJson.afv_fuel_totals.LPG.ghg_reduced_doe
      }, {
        name: "Plug-in Hybrid",
        y: AnnualReportingJson.afv_fuel_totals.PHEV.ghg_reduced_doe
      }]
    }];

    Highcharts.chart('green-gas-by-proj', chartObj(greenGasByProj, 'Greenhouse Gas Emission Reduced by Alternative Fuel Vehicle Project Type'));

    var greenGasByProjTotal = AnnualReportingJson.afv_fuel_totals.totals.ghg_reduced_doe;

    $('#green-gas-by-proj-total').html(addDelimiter(Math.round(greenGasByProjTotal)) + ' tons of CO2e');
  }

  $('.video-div').click(function () {
    $('.videos').hide();

    var videoId = $(this).prop('id').split('-')[2];
    $('#video-' + videoId).show();
  });
})();
